import { ILineStyle } from ".";

export interface ILineDrawable<T = number> {
  lineStyle: ILineStyle<T>;
}

export function instanceOfILineDrawable<T = number>(instance: any): instance is ILineDrawable<T> {
  return instance
      && (instance.lineStyle !== undefined);
}
